module.exports = __webpack_public_path__ + "static/media/scaled-medium.e68dcc4a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-img-listing/scaled-medium.webp
// module id = 1857
// module chunks = 0